import React from 'react'
import { Form, Input, Button } from 'antd'
import { func } from 'prop-types'

import { useCreatePhenologicalState } from '@graphql/mutations'

function ManagePhenologicalStateForm({ afterSubmit }) {
  const [form] = Form.useForm()
  const [createPhenologicalState, { loading }] = useCreatePhenologicalState()

  const onFinish = data => {
    createPhenologicalState({
      variables: {
        data: { ...data },
      },
      refetchQueries: ['GetPhenologicalStatesQuery'],
    }).then(callback => afterSubmit(callback), form.resetFields())
  }

  return (
    <Form onFinish={onFinish} form={form}>
      <Form.Item
        name="name"
        rules={[
          {
            required: true,
            message: `Campo obrigatório`,
          },
        ]}
        hasFeedback
      >
        <Input placeholder="Nome do estado fenológico" size="large" autoFocus />
      </Form.Item>

      <Button
        type="primary"
        htmlType="submit"
        size="large"
        disabled={loading}
        block
      >
        Criar estado fenológico
      </Button>
    </Form>
  )
}

ManagePhenologicalStateForm.propTypes = {
  afterSubmit: func,
}

ManagePhenologicalStateForm.defaultProps = {
  afterSubmit: null,
}

export default ManagePhenologicalStateForm
